export const UNAUTHORIZED = 'Unauthorized';
